import { render, staticRenderFns } from "./HomeStudentList.vue?vue&type=template&id=896aadc6"
import script from "./HomeStudentList.vue?vue&type=script&lang=js"
export * from "./HomeStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports